import React, { useLayoutEffect } from 'react'
import { TextareaViewProps } from './useTextarea'
import styleTextarea from './Textarea.module.scss'

export const TextareaView = (props: TextareaViewProps): JSX.Element => {
  const {
    value,
    label,
    isFixed,
    reference,
    disabled,
    isFocus,
    setIsFocus,
    isDashed,
    classNameValueFocus,
    changeTextarea
  } = props

  const MIN_TEXTAREA_HEIGHT = 0

  useLayoutEffect(() => {
    if (reference) {
      // Reset height - important to shrink on delete

      reference.current.style.height = 'inherit'
      // Set height

      const h = reference.current.scrollHeight

      reference.current.style.height = `${Math.max(
          h,
          MIN_TEXTAREA_HEIGHT
      ) - (!!value && String(value).length > 0 ? 0 : 22)}px`
    }
  }, [value])

  return (
    <div className={styleTextarea._field}>
      <div
        className={
          styleTextarea._field__box +
          (classNameValueFocus(value, isFocus, isFixed)
            ? ' ' +
            classNameValueFocus(value, isFocus, isFixed)
            : '') +
          (isDashed ? ' ' + styleTextarea._field__box_dashed : '')
        }>
        <label>
          {label && (
            <span className={styleTextarea._field__label}>
              {label}
            </span>
          )}
          <textarea
            className={styleTextarea._field__input}
            defaultValue={(!!value && value) || undefined}
            autoComplete="off"
            disabled={disabled}
            ref={reference || undefined}
            // rows={10}
            // cols={20}
            style={{
              minHeight: MIN_TEXTAREA_HEIGHT,
              resize: 'none'
            }}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
              changeTextarea(event)
            }}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }} />
        </label>
      </div>
    </div>
  )
}
